module Branding

open Browser
open Fable.Core.JsInterop
open Shared.Branding

let brandingFromVar = parse (window?BRAND.ToString())

let brandedFooter =
  match brandingFromVar with
  | ICON -> "ICON PM Dashboard"
  | TRANSASH -> "TranshAsh PM Dashboard"
  | SV -> "PM Dashboard"

let brandedLogo =
  match brandingFromVar with
  | ICON -> "/Images/iconlogo.png"
  | TRANSASH -> "/Images/transashlogo.png"
  | SV -> "/Images/svlogo.png"